export const SEARCH_SET_INDEX = "SEARCH_SET_INDEX";
export const SEARCH_SET_QUERY = "SEARCH_SET_QUERY";
export const SEARCH_LOAD_FAILURE = "SEARCH_LOAD_FAILURE";